import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TagsChipsService {
  private _dropdownStatus = new BehaviorSubject<string | null>(null);

  private _counter = 0;

  setDropdown(id: string | null) {
    this._dropdownStatus.next(id);
  }

  getDropdownStatus() {
    return this._dropdownStatus.asObservable();
  }

  getUniqueId() {
    return `u-${(this._counter++).toString(36)}`;
  }
}
